import React from 'react';
import styled from '@emotion/styled'
import { containers, Grid, TextEnterExit } from 'style';
import { Markdown } from '..';


const MarkdownTextComponent = ({ text, backgroundColor, textColor, centerText, leftAlignText, className }) => (
  <Grid.Wrapper id="MarkdownTextComponent" backgroundColor={backgroundColor && backgroundColor.hex} textColor={textColor && textColor.hex}>
    <div className="wrapper">
    <div className="container-fluid">
      <div className="row">
        <div className="col-xs-12">
          <Text centerText={centerText} leftAlignText={leftAlignText}>
            <Markdown
              source={text}
              className={className}
            />
          </Text>
        </div>
      </div>
      </div>
    </div>
  </Grid.Wrapper>
);

const Text = styled.div`

    text-align: ${props => props.centerText ? 'center' : 'left'};
    ${TextEnterExit};

    max-width: 100%;
    @media (min-width: ${containers.ipad}px){
      max-width: ${props => props.leftAlignText ? '100%' : '44.5vw'};
    }
    margin: 0 auto;
`;

export default MarkdownTextComponent;
